const API='/api';
async function request(path,options={}){const r=await fetch(`${API}${path}`,{...options,credentials:'include',headers:{...(options.body?{'Content-Type':'application/json'}:{}),...(options.headers||{})}}),text=await r.text();let body={};try{body=text?JSON.parse(text):{};}catch(_){body={error:text};}if(!r.ok)throw Object.assign(new Error(body?.error||`AI request failed (${r.status})`),{status:r.status,body});return body;}
export const getWebAIContext=()=>typeof window!=='undefined'?(window.__PA_WEB_AI_CONTEXT__||{}):{};
export const invokeWebAI=({prompt,reportLabel='Process Advisor AI',temperature=0.3,responseFormat='json',context,modelId}={})=>{
  const current=getWebAIContext();
  return request('/ai/invoke',{method:'POST',body:JSON.stringify({
    prompt,reportLabel,temperature,responseFormat,
    context:context||current,
    modelId:modelId||current?.model?.id||null,
  })});
};
export const webAISettings={get:()=>request('/ai/settings'),save:p=>request('/ai/settings',{method:'PUT',body:JSON.stringify(p)}),test:()=>request('/ai/test',{method:'POST'})};
